import { mapActions } from "vuex";
import selectAddr from "@/components/selectAddr";
import selectRecAddr from "@/components/selectRecAddr";
import moment from "moment";
import _ from "lodash";
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import getCheckPhone from '@/common/js/checkPhone.js';

const stopReadOnly = {
  addrDetail: false,
  orderPlacerName: false,
  orderPlacerPhone: false,
  planArriveTm: false,
  planSendtm: false,
  jobType: false,
};

export default {
  components: {
    selectAddr,
    selectRecAddr
  },
  data() {
    // 手机号校验
    const checkPhone = getCheckPhone();
    // 手机号校验
    const checkStopPhone = getCheckPhone(false);
    return {
      enquiryId:null,
      sx: {
        vehicleTypeName: '',
        vehicleLength: '',
      },
      bidDays: '',
      bidHours: '',
      bidMinutes: '',
      recAddressList: [],
      thirdPlaceOrder: false,
      effectLoadCapacity: '',
      systemCode: null,
      waitHandelOrderId: null,
      invokeSource: null,
      stopsDisabledSwitch: false,
      stopsReadOnly: [],
      updateSuccRes: {
        orderId: null,
        version: null
      },
      processReasons: [
        { label: '客户需求变更', value: 'R1' },
        { label: '信息填写错误', value: 'R2' },
        { label: '用车时间计划变更', value: 'R3' },
        { label: '增加押车费', value: 'R4' },
        { label: '增加装卸费', value: 'R5' },
        { label: '车辆故障', value: 'R6' },
        { label: '其它', value: 'R0' },
      ],
      isAlter: false,
      uploadUsualLineLoading: false,
      filterAddress: '',
      filename: '',
      changed: false,
      uploadBtn: true,
      activeName: 'single',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24 || time.getTime() > Date.now() + 3600 * 1000 * 24 * 60
        }
      },
      isOrdering: false,
      isOrderAltering: false,
      state: 1,
      show: {
        RobOrder: false,
        SendOrder: false,
        BidOrder: false,
      },
      addAddressVisible: false,
      driverTag: '',
      newAddress: {
        province: '',
        district: '',
        addrDetail: '',
        cityName: '',
        cityCode: '',
        coordinate: '',
        contacts: '',
        phone: '',
        shortName: '',
        rules: {
          contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          shortName: [{ required: true, message: "请输入地址简称", trigger: "blur" }],
          phone: [
            { required: true, validator: checkPhone, trigger: "blur" }
          ],
          addrDetail: [{ required: true, message: "请选择地址", trigger: "change" }],
        }
      },
      addressList: [],
      querystring: '',
      orderType: "single",
      activeTabName: 'first',
      mapVisible: false,
      currentTm: moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
      totalFee: '',
      SFMap: window.SFMap,
      map: {
        markerTpl: null,
        mapIns: null,
        vectorLayer: null,
        markersList: [],
        currVo: null,
        poiset: [],
        inputCityName: '深圳市',
        keyWord: '',
        province: '',
        district: '',
        cityCode: '',
        addrDetail: '',
        cityName: '',
        coordinateLon: null,
        coordinateLat: null,
      },
      form: {
        isSaveFrequentlyLine: false,
        def: {
          days: 0,
          hours: 0,
          minutes: 0
        },
        "expectedPrice": '',
        "outerOrderId": '',
        "quantity": '',
        "uuid": '',
        "totalPrice": '',
        expiryDate: '',
        "biddenStartTm": '',
        "biddenEndTm": '',
        "assignDriverParam": {
          "userId": '',
          "userName": '',
          "driverId": null,
          "driverName": "",
          "driverPhone": "",
          "vehicleSerial": "",
          list: [],
          vehicleId: '',
          carList: [],
        },
        "assignCarrierParam": {
          "userId": '',
          "userName": '',
          "carrierId": null,
          "carrierName": "",
          "type": 1,
        },
        "carrierAssignFlag": null,
        "cargoInfo": "1700",
        "cargoVolume": '',
        "cargoWeight": '',
        "carrierType": 1,
        "comment": "",
        addedComments: [],
        "dataOwner": null,
        "needReceipt": 2,
        "reachTm": '',
        "receiptAddress": "",
        "receiptName": "",
        "receiptPhone": "",
        "receiptType": 1,
        start: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 1,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveTm": '',
          "planSendtm": '',
          "sortNum": 1
        },
        stops: [],
        end: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 2,
          "lineDistance": 0,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveTm": '',
          "planSendtm": '',
          "sortNum": 2
        },
        "saasPassZoneVOs": [],
        "userId": '',
        "tenantId": '',
        "totalLineDistance": '',
        "totalRunTm": 0,
        "vehicleLength": null,
        "vehicleType": "",
        "mode": 1
      },
      checkStopPhone,
      rules: {
        processReason: [{ required: true, message: "请选择修改原因", trigger: "change" }],

        'start.addrDetail': [{ required: true, message: "请输入发货地址", trigger: "change" }],
        'start.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'start.orderPlacerPhone': [{ required: true, trigger: "change", validator:checkPhone }],
        'start.planArriveTm': [{ required: true, message: "请输入到场时间", trigger: "change" }],
        'start.planSendtm': [{ required: true, message: "请输入计划发车时间", trigger: "change" }],

        'end.addrDetail': [{ required: true, message: "请输入收货地址", trigger: "change" }],
        'end.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'end.orderPlacerPhone': [{ required: true, trigger: "change", validator:checkPhone }],
        'end.planArriveTm': [{ required: true, message: "请选择计划到达时间", trigger: "change" }],

        cargoInfo: [{ required: true, message: "请选择货物信息", trigger: "change" }],
        cargoWeight: [{ required: true, message: "请输入货物重量", trigger: "change" }],
        cargoVolume: [{ required: true, message: "请输入货物体积", trigger: "change" }],
        dataOwner: [{ required: true, message: "请选择订单归属", trigger: "change" }],

        receiptAddress: [{ required: true, message: "请输入签收地址", trigger: "change" }],
        receiptName: [{ required: true, message: "请输入联系人姓名", trigger: "change" }],
        receiptPhone: [{ required: true, trigger: "change", validator:checkPhone }],

        'carrierType': [{ required: true, message: "请选择承运对象", trigger: "change" }],
        'assignDriverParam.driverName': [{ required: true, message: "请输入承运司机", trigger: "change" }],
        'assignDriverParam.vehicleId': [{ required: true, message: "请选择承运车辆", trigger: "change" }],
        'assignCarrierParam.carrierName': [{ required: true, message: "请输入承运公司", trigger: "change" }],

        expectedPrice: [{ required: true, message: "请输入期望运费", trigger: "change" }],
        biddenStartTm: [{ required: true, message: "请输入竞价开始时间", trigger: "change" }],
        expiryDate: [{ required: true, message: "请选择询价结束时间", trigger: "change" }],

        quantity: [
          {
            trigger: "change",
            required: false,
            validator: (rule, value, callback) => {
              if (value !== "") {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
                  callback(new Error("请填写大于0的数字"));
                } else {
                  if (Number(value) == 0) {
                    callback(new Error("请填写大于0的数字"));
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            }
          }
        ]
      },
      prev: {
        "cargoInfos": [],
        "dataOwner": [],
        modes: '',
        "ownerName": "",
        "placerNames": [],
        comments: ["三不超", "需雨布", "带尾板", "无禁区", "全程高速"],
        vehicle: {
          Maps: null,
          typeMapLens: [],
          lens: [],
          "vehicleLength": null,
          "vehicleType": "",
          "plVehicleCode": ""
        },
      },
    };
  },
  watch: {
    'prev.vehicle.vehicleType': function (val) {
      this.prev.vehicle.vehicleLength = null
      this.prev.vehicle.typeMapLens.forEach(item => {
        if (item.plVehicleType == val) {
          this.prev.vehicle.plVehicleCode = item.plVehicleCode
          this.prev.vehicle.lens = item.lens
        }
      })
    },
    'form.start.coordinate': function () {

      this.calcDisAndTm()
    },
    'form.end.coordinate': function () {

      this.calcDisAndTm()
    },
    'form.start.planSendtm': function () {

      this.calcDisAndTm();
      this.calcTotoalRunTm();
    },
    'form.end.planArriveTm': function () {
      this.calcTotoalRunTm();
    },
    'form.totalLineDistance': function () {
      this.calcPrice();
    },
    'form.expectedPrice': _.debounce(function () {
      this.totalFee = null
      this.calcPrice()
    }, 300),
    activeTabName: _.debounce(function () {
      this.totalFee = null
      this.calcPrice()
    }, 300),
    'form.carrierType': _.debounce(function () {
      this.calcPrice()
    }, 1000),
    'tenantId': function (val) {
      this.form.tenantId = val;
    },
    'userId': function (val) {
      this.form.userId = val;
    },
    'telephone': function (val) {
      this.form.start.orderPlacerPhone = val;
    }
  },
  computed: {
    mode: function () {
      let mode = null;
      switch (this.prev.modes) {
        case '1': mode = '1'; break;
        case '2':
        case '3':
        case '1,2':
        case '1,3':
        case '2,3':
        case '1,2,3': mode = '2'; break;
        default: mode = '2'; break;
      }
      return mode
    },
    tenantId: function () {
      return this.$store.state.login.tenantId;
    },
    userId: function () {
      return this.$store.state.login.userId;
    },
    userName: function () {
      return this.$store.state.login.userName;
    },
    telephone: function () {
      return this.$store.state.login.telephone;
    },
  },
  mounted() {
    this.form.userId = this.$store.state.login.userId
    this.form.tenantId = this.$store.state.login.tenantId
    this.queryAddressList();
    this.queryCarTypeList();
    Promise.all([this.initPlaceApiIns, this.queryAddressApiIns, this.queryAddressApiIns2, this.queryCarTypeListApiIns]).then(res => {
      this.initFinishCallBack1();
      this.initFinishCallBack2();
      this.initFinishCallBack3();
    })
  },
  created() {
    let menuInterval = setInterval(() => {
      let map = JSON.parse(sessionStorage.getItem('menuMap'))
      if (map) {
        clearInterval(menuInterval)
        let submenuList = map['Shipments'].split('-');
        submenuList.forEach((item, i) => {
          this.show[item] = true;
          i == 0 && (this.activeTabName = submenuList.indexOf('SendOrder') > -1 ? 'first' : 'second')
        });
      }
    }, 30);

    this.initPlaceApiIns = this.initPlaceApi({}).then(res => {
      this.prev.cargoInfos = res.cargoInfos
      this.prev.dataOwner = res.dataOwner
      this.prev.modes = res.modes
      this.prev.ownerName = res.ownerName
      this.prev.placerNames = res.placerNames

      this.form.start.orderPlacerName = res.placerNames[0]
      if (res.dataOwner.length == 1) {
        this.form.dataOwner = res.dataOwner[0].value
      }
    }).catch(e => { });

    let time = moment().add(5, 'minutes').format("YYYY-MM-DD HH:mm")
    this.form.biddenStartTm = time + ':00'
  },
  methods: {
    ...mapActions([
      'addAddressApi',
      'queryAddressApi',
      'queryAddrByCoordinateApi',
      'queryAddrByKeywordApi',
      'initPlaceApi',
      'calcDisAndTmApi',
      'calcPriceApi',
      'placeOrderApi',
      'getDriverInfoApi',
      'getCarrierInfoApi',
      'queryCarTypeListApi',
      'getOrderAlterInfoApi',
      'uploadToSaveOrderApi',
      'updateOrderApi',
      'getWaitHandleOrderByIdApi',
      'thirdPlaceOrderApi',
      'orderEnquiryApi'
    ]),
    biddenEndTmBlur() {
      if (!this.form.biddenStartTm || !this.form.biddenEndTm) {
        this.bidDays = ''
        this.bidHours = ''
        this.bidMinutes = ''
        return;
      } else {
        let a = moment(this.form.biddenStartTm)
        let b = moment(this.form.biddenEndTm)
        let m = b.diff(a, 'minutes')
        if (m > 0) {
          let days = moment.duration(m, 'minutes').days()
          let hours = moment.duration(m, 'minutes').hours()
          let minutes = moment.duration(m, 'minutes').minutes()
          this.bidDays = days
          this.bidHours = hours
          this.bidMinutes = minutes
        } else {
          this.$message({
            type: 'warning',
            message: '竞价结束时间必须大于开始时间'
          })
          this.bidDays = ''
          this.bidHours = ''
          this.bidMinutes = ''
          return;

        }
      }
    },
    calcEndTime() {
      if (!this.form.biddenStartTm) return;
      let total = 0;
      total = parseInt(this.bidDays ? this.bidDays : 0) * 24 * 60 + parseInt(this.bidHours ? this.bidHours : 0) * 60 + parseInt(this.bidMinutes ? this.bidMinutes : 0)
      this.form.biddenEndTm = moment(this.form.biddenStartTm).add(total, 'minutes').format('YYYY-MM-DD HH:mm:ss')
    },
    limitNumber(val) {
      let tpl = val.replace(/[^0-9.]/g, '')
      this.form.expectedPrice = tpl
    },
    onAlterOrder() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.checkTm()) return;
          let params = Object.assign({}, this.form);
          this.isOrdering = true
          params.saasPassZoneVOs = [params.start, ...params.stops, params.end];
          params.reachTm = params.start.planArriveTm;
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : '');
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);

          if (this.activeTabName == 'second' || this.activeTabName == 'third') {
            params.carrierAssignFlag = 'N'
            params.vehicleType = this.prev.vehicle.plVehicleCode
            params.vehicleLength = this.prev.vehicle.vehicleLength
            params.mode = '';
          } else {
            params.carrierAssignFlag = 'Y'
            if (params.carrierType == '2') {
              params.vehicleType = this.prev.vehicle.plVehicleCode
              params.vehicleLength = this.prev.vehicle.vehicleLength
            }
            params.mode = this.mode;

          }

          if (this.activeTabName == 'second') {
            params.dispatchMode = 1
          } else if (this.activeTabName == 'third') {
            params.dispatchMode = 2
          } else {
            params.dispatchMode = 0
          }

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId

          let flag = true
          for (let i = 0; i < params.saasPassZoneVOs.length - 1; i++) {
            if (!this.compareTime(params.saasPassZoneVOs[i].planSendtm, params.saasPassZoneVOs[i + 1].planArriveTm)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          }
          params.orderId = this.alterOrderId
          this.updateOrderApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.state = 3
            Object.assign(this.form, this.$options.data().form)
            this.form.userId = this.$store.state.login.userId
            this.form.tenantId = this.$store.state.login.tenantId
            this.totalFee = ''
            this.form.uuid = ''
            this.updateSuccRes.orderId = res.orderId
            this.updateSuccRes.version = res.version

          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    initFinishCallBack1() {
      this.handleUsualLineJump();
    },
    initFinishCallBack2() {
      this.alterOrderId = sessionStorage.getItem('alterOrderId')
      if (this.alterOrderId) {
        sessionStorage.removeItem('alterOrderId')
        this.isAlter = true
        this.getOrderAlterInfo();
      }
    },
    initFinishCallBack3() {
      this.handleWaitHandleOrderJump();
    },
    getOrderAlterInfo() {
      this.getOrderAlterInfoApi({ orderId: this.alterOrderId }).then(res => {
        this.isAlter_firstTrigger = true
        this.fillOrderForm(res)
        setTimeout(() => { this.isAlter_firstTrigger = false }, 100)
      }).catch(e => { });
    },
    fillOrderForm(res) {
      let dto = res.orderEditAddrDtos
      Object.assign(this.form.start, dto[0])
      Object.assign(this.form.end, dto[dto.length - 1])
      this.form.stops = [...dto.slice(1, dto.length - 1)]

      this.form.cargoInfo = res.cargoInfo
      this.form.cargoWeight = res.cargoWeight
      this.form.cargoVolume = res.cargoVolume
      this.form.outerOrderId = res.outerOrderId ? res.outerOrderId : ''

      this.form.dataOwner = res.dataOwner
      this.form.comment = res.comment
      this.form.needReceipt = res.needReceipt
      this.form.receiptAddress = res.receiptAddress
      this.form.receiptName = res.receiptName
      this.form.receiptPhone = res.receiptPhone

      this.activeTabName = (res.dispatchMode == 0 ? 'first' : 'other')
      this.form.carrierType = res.carrierType

      this.form.expectedPrice = res.price
      this.form.totalLineDistance = res.distance

    },
    onTriggerFile() {
      this.$refs.batchFile.dispatchEvent(new MouseEvent('click'))
    },
    eFileChange() {
      let dom = this.$refs.batchFile
      let file = dom.files[0]
      if (file) {
        this.changed = true
        let name = file.name
        let size = file.size
        let type = file.type
        this.filename = file.name
        this.uploadBtn = false
      } else {
        this.changed = false
        let name = null;
        let size = null;
        let type = null;
        this.filename = null;
        this.uploadBtn = true;
      }
    },
    beforeUpload(file) {
      let name = file.name.toUpperCase();
      const isExcel = name.slice(-'XLSX'.length) == 'XLSX';
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isExcel) {
        return '上传文件只能是 xlsx 格式!';
      }
      if (!isLt10M) {
        return '上传文件大小不能超过 1MB!';
      }
      return null;
    },
    handleSuccess(res, file) {
      console.log(res, file)
    },
    handleRemove() { },
    clearUploadFile() {
      document.getElementById('cmFile').value = '';
      this.filename = '';
      this.changed = false;
      this.uploadBtn = true;
    },
    submitUpload() {
      if (!document.getElementById('cmFile').files[0]) {
        this.$message({
          type: "error",
          message: '请选择文件！'
        });
        return;
      }
      let beforeUploadResult = this.beforeUpload(document.getElementById('cmFile').files[0]);
      if (beforeUploadResult) {
        this.$message({
          type: "error",
          message: beforeUploadResult
        });
        return;
      }
      this.uploadUsualLineLoading = true;
      let formData = new window.FormData();
      formData.append('cmFile', document.getElementById('cmFile').files[0]);
      this.uploadToSaveOrderApi(formData).then(res => {
        debugger
        this.uploadUsualLineLoading = false;
        const {result, succ } = JSON.parse(res.request.response);
        if (succ === 'fail') {
          this.$message({
            type: "error",
            message: res.data.msg
          });
          return;
        }

        // res = JSON.parse(res.request.response).result;
        // this.uploadUsualLineLoading = false;
        let tip = "导入成功记录数" + result.succSum + "条,导入失败记录数" + result.failSum + "条,详情请查看附件!";
        this.$notify({
          title: '提示',
          message: tip,
          type: 'warning',
          duration: 15000
        });
        this.clearUploadFile();
        let preUrl = getMvcUrl() + '/saas/downLoad/downLoadOssFile?objectName=' + result.filePath;
        window.open(preUrl);
      }).catch(e => {
        if (e && e.succ === 'fail' && e.msg) {
          this.$message({
            type: "error",
            message: e.msg
          });
        }
        this.uploadUsualLineLoading = false;
      }).finally(() => { });
    },
    handletTabClick() { },
    calcTotoalRunTm() {
      let a = moment(this.form.start.planSendtm)
      let b = moment(this.form.end.planArriveTm)
      let m = b.diff(a, 'minutes')
      if (this.form.start.planSendtm && this.form.end.planArriveTm && m > 0) {
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.totalRunTm = m
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
      }
    },
    compareTime(startTm, endTm) {
      let result = moment(endTm).diff(moment(startTm), 'minutes')
      return result > 0;
    },
    onCheckDetail() {
      sessionStorage.setItem('enquiryId', this.enquiryId)
      this.$router.push('/manage/enquiryList')
    },
    onCheckOrderDeal() {
      sessionStorage.setItem('alterOrderId', this.updateSuccRes.orderId)
      sessionStorage.setItem('version', this.updateSuccRes.version)
      this.$router.push('/manage/OrderProcess')
    },
    onContinue() {
      this.state = 1;
    },
    queryCarTypeList() {
      this.queryCarTypeListApiIns = this.queryCarTypeListApi({}).then(res => {
        this.prev.vehicle.Maps = res;
        this.prev.vehicle.typeMapLens = res.typeMapLens;
        this.prev.vehicle.lens = res.lens;
      })
    },
    onOpenAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    oncloseAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    onAddAddress() {
      this.addAddressVisible = true
    },
    onAddAddressconfirm() {
      let params = Object.assign({}, this.newAddress)
      params.address = params.addrDetail
      delete params.addrDetail
      delete params.rules

      this.$refs.newAddressFormRef.validate((valid) => {
        if (valid) {
          this.addAddressApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '新增成功'
            });
            this.addAddressVisible = false
            this.queryAddressList()
          })
        }
      })
    },
    querySearch(qs, cb) {
      let list = this.addressList;
      let results = qs ? list.filter(this.filterFun(qs)) : list;
      cb(results);
    },
    filterFun(qs) {
      return (item) => {
        return (item.shortName && item.shortName.indexOf(qs) !== -1) || item.address.indexOf(qs) !== -1 || item.contacts.indexOf(qs) !== -1 || item.phone.indexOf(qs) !== -1;
      }
    },
    handleSelect(item, obj) {
      obj.addrDetail = item.address
      obj.cityCode = item.cityCode
      obj.cityName = item.cityName
      obj.coordinate = item.coordinate
      obj.orderPlacerPhone = item.phone
      obj.orderPlacerName = item.contacts 

    },
    queryAddressList() {
      this.queryAddressApiIns = this.queryAddressApi({ pageSize: 10000, pageNum: 1 }).then(res => {
        this.addressList = res.rows
      }).catch(e => { })
      this.queryAddressApiIns2 = this.queryAddressApi({ pageSize: 10000, pageNum: 1, addrType: 2 }).then(res => {
        this.recAddressList = res.rows
      }).catch(e => { })
    },
    mapCarrierStatus(status) {
      let res = '';
      switch (status) {
        case 1: res = '注册审核驳回'; break;
        case 2: res = '启用'; break;
        case 3: res = '草稿'; break;
        case 4: res = '待注册审核'; break;
        case 5: res = '黑名单'; break;
        case 11: res = '考察审核驳回'; break;
        case 12: res = '准入审核驳回'; break;
        case 41: res = '待考察审核'; break;
        case 42: res = '待准入审核'; break;
        case 7: res = '招投标黑名单'; break;
        case 8: res = '已退出'; break;
        default: res = '其他'; break;
      }
      return res
    },
    onSearchDriver(queryString, cb) {
      let params = {
        name: queryString,
        mode: '',
        planSendTm: (this.form.start.planSendtm ? this.form.start.planSendtm : this.currentTm)
      }
      this.form.assignDriverParam.carList = [];
      if (!this.form.assignDriverParam.driverName) {
        return;
      }
      this.getDriverInfoApi(params).then(res => {
        this.effectLoadCapacity = ''
        this.form.assignDriverParam.list = res
        let list = this.form.assignDriverParam.list;
        let results = queryString ? list.filter(this.createFilter(queryString)) : list;
        cb(results);
      })
    },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || item.mobilephone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandSelectDriver(item) {
      if (item.status != 1) {
        this.$message({
          type: 'warning',
          message: '司机未认证，请通知司机在顺陆APP进行信息验证'
        })
        /* this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        }); */
        return;
      }
      this.form.assignDriverParam.driverName = item.name
      this.form.assignDriverParam.driverId = item.driverId
      this.form.assignDriverParam.driverPhone = item.mobilephone
      this.form.assignDriverParam.userId = item.userId
      this.form.assignDriverParam.userName = item.userName
      this.form.assignDriverParam.carList = this.addFieldToCarList(item.vehicleList)
      this.driverTag = item.driverTag

    },
    addFieldToCarList(list) {
      if (list.length > 0) {
        list.forEach(item => {
          let state = item.status == 1 ? '已认证' : item.status == 2 ? '未认证' : '被占用'
          item.label = item.vehicleCode + '（' + item.vehicleTypeName + ' ' + item.vehicleLength + '米 ）' + state
          if (item.status != 1) {
            item.disabled = true
          }
        })
        return list;
      }
    },
    onSearchCarrier(queryString, cb) {
      let params = { name: queryString }
      if (!queryString) {
        return;
      }
      this.getCarrierInfoApi(params).then(res => {
        let list = res;
        let results = queryString ? list.filter(this.createFilter2(queryString)) : list;
        cb(results);
      })
    },
    createFilter2(queryString) {
      return (item) => {
        return (item.blName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandSelectCarrier(item) {
      this.form.assignCarrierParam.carrierId = item.id
      this.form.assignCarrierParam.carrierName = item.blName
      // this.form.assignCarrierParam.type = item.type
      this.form.assignCarrierParam.userName = item.userName
      this.form.assignCarrierParam.userId = item.userId
    },
    onCarSelect(id) {
      this.form.assignDriverParam.carList.forEach(item => {
        if (id == item.vehicleId) {
          this.form.vehicleType = item.vehicleType
          this.form.vehicleLength = item.vehicleLength
          this.form.assignDriverParam.vehicleSerial = item.vehicleCode
          this.effectLoadCapacity = item.effectLoadCapacity
          /* 保存 */
          this.sx.vehicleTypeName = item.vehicleTypeName
          this.sx.vehicleLength = item.vehicleLength
        }
      })
    },
    checkTm() {
      let validTmRes = true
      if (!this.compareTime(this.form.start.planArriveTm, this.form.start.planSendtm)) {
        validTmRes = false
      }
      this.form.stops.forEach(item => {
        if (!this.compareTime(item.planArriveTm, item.planSendtm)) {
          validTmRes = false
        }
      });
      if (!validTmRes) {
        this.$message({
          type: 'warning',
          message: '计划发车时间必须大于到场时间'
        })
        return validTmRes
      }
      return true
    },
    checkWaitHandleOrder() {
      if (!this.checkWaitHandleOrderVehicleInfo()) {
        return false;
      }
      if (!this.checkWaitHandleOrderStatus()) {
        return false;
      }
      return true;
    },
    checkWaitHandleOrderVehicleInfo() {
      if (this.invokeSource === 'waitHandelOrder' && this.activeTabName === 'first' && this.show.SendOrder && this.form.carrierType == 1) {
        if (this.prev.vehicle.plVehicleCode && this.prev.vehicle.vehicleLength && this.form.assignDriverParam.vehicleId) {
          for (let i = 0; i < this.form.assignDriverParam.carList.length; i++) {
            if (this.form.assignDriverParam.carList[i].vehicleId == this.form.assignDriverParam.vehicleId) {
              if (this.form.assignDriverParam.carList[i].vehicleType != this.prev.vehicle.plVehicleCode) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车型不符合用车要求'
                });
                return false;
              }
              if (this.form.assignDriverParam.carList[i].vehicleLength * 1 < this.prev.vehicle.vehicleLength * 1) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车长不符合用车要求'
                });
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    checkWaitHandleOrderStatus() {
      let that = this;
      if (this.invokeSource === 'waitHandelOrder') {
        let params = {};
        params.id = this.waitHandelOrderId;
        this.getWaitHandleOrderByIdApi(params).then(res => {
          if (res.status != 0 && res.status != 3) {
            that.$message({
              type: "error",
              message: '该订单状态为已处理或已取消,不允许发货'
            });
            return false;
          }
          return true;
        }).catch(e => {
          if (e && e.succ === 'fail' && e.msg) {
            that.$message({
              type: "error",
              message: e.msg
            });
          }
          that.$message({
            type: "error",
            message: '无法获取该订单状态,不允许发货'
          });
          return false;
        }).finally(() => {

        });
      }
      return true;
    },
    onPlaceOrder() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.checkTm()) return;
          if (!this.checkWaitHandleOrder()) {
            return;
          }
          if(!this.prev.vehicle.vehicleType || !this.prev.vehicle.vehicleLength){
            this.$message({
              type: "warning",
              message: '请选择车型车长'
            });
            return;
          }
          let params = Object.assign({}, this.form);

          this.isOrdering = true;
          params.saasPassZoneVOs = [params.start, ...params.stops, params.end];
          params.reachTm = params.start.planArriveTm;
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : '');
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);
          params.vehicleType = this.prev.vehicle.plVehicleCode
          params.vehicleLength = this.prev.vehicle.vehicleLength
          params.dispatchMode = -1

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId

          let flag = true
          for (let i = 0; i < params.saasPassZoneVOs.length - 1; i++) {
            if (!this.compareTime(params.saasPassZoneVOs[i].planSendtm, params.saasPassZoneVOs[i + 1].planArriveTm)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          }
          if (!params.totalLineDistance || params.totalLineDistance < 0 || params.totalLineDistance == 0) {
            this.$message({
              type: 'warning',
              message: '请输入正确的总里程'
            })
            this.isOrdering = false
            return;
          }

          this.orderEnquiryApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '询价成功'
            })
            this.state = 2
            Object.assign(this.form, this.$options.data().form)
            this.form.userId = this.$store.state.login.userId
            this.form.tenantId = this.$store.state.login.tenantId
            this.totalFee = ''
            this.form.uuid = ''
            this.enquiryId = res;
          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    calcPrice() {
      let price = this.form.expectedPrice
      let driverTag = this.driverTag
      let distance = this.form.totalLineDistance
      let planSendTm = this.form.start.planSendtm ? this.form.start.planSendtm : this.currentTm
      let type = this.form.carrierType == '2' ? 'B' : 'C'
      let effectLoadCapacity = this.effectLoadCapacity
      let params = {
        price,
        driverTag,
        distance,
        planSendTm,
        type,
        effectLoadCapacity
      }
      if (price != '' && /^[\d.]+$/.test(price)) {
        this.totalFee = price
        this.form.totalPrice = ('' + price)
        return;
      }
      /* if (!price || !distance || this.activeTabName != 'first') {
        return;
      }
      if (type == 'B') {
        this.totalFee = price
        this.form.totalPrice = ('' + price)
        return;
      }
      this.calcPriceApi(params).then(res => {
        this.totalFee = res.price
        this.form.uuid = res.uuid
        this.form.totalPrice = ('' + res.price)
      }).catch(e => { }) */
    },
    onTabsClick() {

    },
    onAddComment(item) {
      if (this.form.addedComments.indexOf(item) == -1) {
        this.form.addedComments.push(item)
      } else {
        this.form.addedComments.pop(item)
      }
      this.form.comment = this.form.addedComments.join(' ')
    },
    onAddStop() {
      if (this.form.stops.length == 10) {
        this.$message({
          type: 'warning',
          message: '最多添加10个经停点'
        })
        return;
      }
      let sortNum = this.form.stops.length + 2
      let stop = {
        "addrDetail": "",
        "cityCode": "",
        "cityName": "",
        "coordinate": "",
        "jobType": null,
        "lineDistance": '',
        "orderPlacerName": "",
        "orderPlacerPhone": "",
        "planArriveTm": '',
        "planSendtm": '',
        "sortNum": sortNum
      }
      this.form.stops.push(stop);
      this.form.end.sortNum = sortNum + 1;
    },
    onDeleteStop(index) {
      let sortNum = this.form.stops.length
      this.form.stops.splice(index, 1);
      this.form.stops.forEach((item, index) => {
        item.sortNum = index + 2
      })
      this.form.end.sortNum = sortNum + 1
    },
    emapopen(obj) {
      let nodelist = document.querySelectorAll(".el-autocomplete-suggestion.el-popper");
      for (let i = 0; i < nodelist.length; i++) {
        nodelist[i].style.display = "none";
      }
    },
    onOpenMap(obj, type) {
      this.mapVisible = true;
      this.map.currVo = obj;
    },
    eMapOpened() {
      this.$refs.keywordRef.focus();
      if (!this.map.mapIns) {
        this.map.mapIns = this.SFMap.map("map", {
          center: [22.524729, 113.940159],
          zoom: 15
        });
        this.map.vectorLayer = this.SFMap.vectorLayer({ map: this.map.mapIns });
        this.map.mapIns.on("click", this.onMapClick);
      }
    },
    eMapClosed() {
      this.map.cityCode = ''
      this.map.keyWord = ''
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.removeMarkersList();
    },
    onMapClick(e) {
      this.map.coordinateLat = e.latlng.lat.toFixed(6);
      this.map.coordinateLon = e.latlng.lng.toFixed(6);
      let coordinate = this.map.coordinateLon + ',' + this.map.coordinateLat
      this.$message({
        type: 'info',
        message: '查询中...'
        , duration: 1000
      });
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.map.markerTpl = this.SFMap.marker([this.map.coordinateLat, this.map.coordinateLon]);
      this.map.vectorLayer.addLayer(this.map.markerTpl);
      this.queryAddrByCoordinateApi({ coordinate: coordinate }).then(res => {
        this.fillMapInfo(res.name, res.city, res.regcode, coordinate, res.province, res.district)
      })
    },
    calcDisAndTm() {
      let srcCoordinate = this.form.start.coordinate
      let destCoordinate = this.form.end.coordinate
      let planDepartTm = this.form.start.planSendtm
      if (!srcCoordinate || !destCoordinate || !planDepartTm) {
        return;
      }
      if (this.isAlter_firstTrigger) return;
      if (this.is_shunxin_order && this.form.totalLineDistance) return;
      let params = {
        vehicleLength: 4.2,
        srcCoordinate,
        destCoordinate,
        planDepartTm
      }
      this.calcDisAndTmApi(params).then(res => {
        this.form.totalLineDistance = res.distance
        this.form.totalRunTm = res.tm
        let m = res.tm
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
        if (this.form.start.planSendtm) {
          //如果是待处理订单过来的并且目的地计划到车时间不为空，则不可以修改此字段的值
          if (this.invokeSource == 'waitHandelOrder' && this.readOnly.endPlanArriveTm) {
            return;
          }
          this.form.end.planArriveTm = moment(this.form.start.planSendtm).add(m, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
      })
    },
    fillMapInfo(addrDetail, cityName, cityCode, coordinate, province, district) {
      this.map.cityName = cityName;
      this.map.addrDetail = addrDetail;
      this.map.cityCode = cityCode;
      this.map.coordinate = coordinate;
      this.map.inputCityName = cityName;
      this.map.keyWord = addrDetail;

      this.map.province = province;
      this.map.district = district;
    },
    addMarker(arr) {
      let layer = this.map.vectorLayer;
      arr.forEach((item, index) => {
        let address = item.name;
        let addrDetail = item.adname + item.shortName
        let province = ''
        let o = item.lnglat.split(',')
        let coord = [o[1], o[0]]
        if (index == 0) {
          this.moveMap(coord)
        }
        if (item.adname.indexOf('省') > 0) {
          province = ''
        } else {
          province = ''
        }
        let iconMarker = this.SFMap.marker(coord, {
          iconIndex: index + 1
        }).on("click", () => {
          this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
        }).bindTooltip(address);
        layer.addLayer(iconMarker);
        this.map.markersList.push(iconMarker);
      });
    },
    removeMarkersList() {
      if (this.map.markersList && this.map.markersList.length > 0) {
        for (let i = 0; i < this.map.markersList.length; i++) {
          this.map.vectorLayer.removeLayer(this.map.markersList[i]);
        }
        this.map.markersList = [];
      }
    },
    moveMap(coord) {
      this.map.mapIns.panTo(coord);
    },
    onhandleCommand(item) {
      let addrDetail = item.adname + item.shortName
      let o = item.lnglat.split(',')
      let coord = [o[1], o[0]]
      let province = ''
      if (item.adname.indexOf('省') > 0) {
        province = ''
      } else {
        province = ''
      }
      this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
      this.moveMap(coord)
    },
    queryTipByKeyword(cb) {
      let params = {
        'cityName': this.map.inputCityName,
        'keyWord': this.map.keyWord,
        noFailMsg: true
      }
      if (!this.map.keyWord) {
        this.$message({
          type: 'warning',
          message: '请输入城市和地址关键字！'
        });
        this.searchList = []
        return cb(this.searchList)
      }
      this.$refs.keywordRef.activated = true
      this.queryAddrByKeywordApi(params).then(res => {
        const poiset = (res || {}).poiset || []
        this.searchList = poiset.map(ele => {
          return {
            ...ele,
            value: ele.name
          }
        })
        cb(this.searchList)
        this.map.poiset = poiset
        this.addMarker(poiset);
        if (!this.searchList.length) {
          this.$message({
            type: 'warning',
            message: '地址不存在，请重试输入地址'
          });
        }
      })
    },
    onSearchAddr(querystring, cb) {
      if (!querystring) {
        this.searchList = []
        return cb(this.searchList)
      }

      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }

      if (this.map.keyWord.indexOf('市') > -1) {
        this.map.inputCityName = this.map.keyWord.split('市')[0]
      } else {
        this.map.inputCityName = ''
      }
      
      this.queryTipByKeyword(cb);
      this.removeMarkersList();
    },
    onAddrconfirm() {
      if (this.map.keyWord && this.searchList && this.searchList.length === 1) {
        this.onhandleCommand(this.searchList[0])
      }

      if (!this.map.keyWord || !this.map.coordinate) {
        this.$message({
          type: 'warning',
          message: '请输入关键字搜索，再选取地址！'
        });
        return;
      }
      this.map.currVo.addrDetail = this.map.addrDetail
      this.map.currVo.cityCode = this.map.cityCode
      this.map.currVo.cityName = this.map.cityName
      this.map.currVo.coordinate = this.map.coordinate

      this.map.currVo.province = this.map.province
      this.map.currVo.district = this.map.district

      this.mapVisible = false;
    },
    inputFilterAddresss(val) {
      this.addressList = this.addressList
    },
    onSelectAddr(data, form) {
      form.addrDetail = data.address
      form.cityCode = data.cityCode
      form.cityName = data.cityName
      form.coordinate = data.coordinate
      form.orderPlacerName = data.contacts
      form.orderPlacerPhone = data.phone
    },
    onSelectRecAddr(data, form) {
      form.receiptAddress = data.address
      form.receiptName = data.contacts
      form.receiptPhone = data.phone
    },

    downLoadTpl(tplName) {
      let preUrl = getMvcUrl() + '/saas/orderCore/downLoadTpl?tplName=' + tplName;
      window.open(preUrl);
    },
    handleUsualLineJump_buildPassInfo(srcObj, targetObj) {
      targetObj.addrDetail = srcObj.addrDetail;
      targetObj.cityCode = srcObj.cityCode;
      targetObj.cityName = srcObj.cityName;
      targetObj.coordinate = srcObj.coordinate;
      if (srcObj.jobType) {
        targetObj.jobType = srcObj.jobType;
      }
      if (srcObj.orderPlacerName) {
        targetObj.orderPlacerName = srcObj.orderPlacerName;
      }
      if (srcObj.orderPlacerPhone) {
        targetObj.orderPlacerPhone = srcObj.orderPlacerPhone;
      }
      targetObj.sortNum = srcObj.sortNum;
    },
    //处理常用线路通过再来一单的操作
    handleUsualLineJump() {
      let that = this;
      let paramKey = 'usualLineToShipmentsParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
          }
        }
        this.form.dataOwner = shipmentsObjs.dataOwner;
        this.form.cargoInfo = shipmentsObjs.cargoType;
        this.form.cargoVolume = shipmentsObjs.cargoVolume;
        this.form.cargoWeight = shipmentsObjs.cargoWeight;
        this.form.comment = shipmentsObjs.comment;
        this.form.totalLineDistance = shipmentsObjs.lineDistance;
        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          this.form.receiptName = shipmentsObjs.receiptName;
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
        }
        this.form.expectedPrice = shipmentsObjs.expectedPrice * 1;
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            window.setTimeout(function () { that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength; }, 3000);
            break;
          }
        }
      }
    },
    handleWaitHandleOrderJump() {
      let fields = ['cargoInfo', 'cargoVolume', 'cargoWeight', 'quantity', 'outerOrderId', 'totalLineDistance', 'comment'];
      let that = this;
      let paramKey = 'waitHandleOrderParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        this.invokeSource = 'waitHandelOrder';
        this.thirdPlaceOrder = true;
        this.stopsDisabledSwitch = true;
        this.readOnly.hideAddStopBtn = true;
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.waitHandelOrderId = shipmentsObjs.id;
        this.systemCode = shipmentsObjs.systemCode;

        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          if (shipmentsObjs.receiptAddress) {
            this.readOnly.receiptAddress = true;
          }
          this.form.receiptName = shipmentsObjs.receiptName;
          if (shipmentsObjs.receiptName) {
            this.readOnly.receiptName = true;
          }
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
          if (shipmentsObjs.receiptPhone) {
            this.readOnly.receiptPhone = true;
          }
        }

        if (shipmentsObjs.needReceipt) {
          this.readOnly.needReceipt = true;
        }

        if (shipmentsObjs.start) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
          if (this.form.start.addrDetail) {
            this.readOnly.startAddrDetail = true;
          }
          if (shipmentsObjs.start.orderPlacerName) {
            this.readOnly.startOrderPlacerName = true;
          }
          if (shipmentsObjs.start.orderPlacerPhone) {
            this.readOnly.startOrderPlacerPhone = true;
          }
          this.form.start.planArriveTm = shipmentsObjs.start.planArriveTm;
          if (shipmentsObjs.start.planArriveTm) {
            this.readOnly.startPlanArriveTm = true;
          }
          this.form.start.planSendtm = shipmentsObjs.start.planSendtm;
          if (shipmentsObjs.start.planSendtm) {
            this.readOnly.startPlanSendtm = true;
          }
        }
        if (shipmentsObjs.end) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
          if (this.form.end.addrDetail) {
            this.readOnly.endAddrDetail = true;
          }
          if (shipmentsObjs.end.orderPlacerName) {
            this.readOnly.endOrderPlacerName = true;
          }
          if (shipmentsObjs.end.orderPlacerPhone) {
            this.readOnly.endOrderPlacerPhone = true;
          }
          this.form.end.planArriveTm = shipmentsObjs.end.planArriveTm;
          if (shipmentsObjs.end.planArriveTm) {
            this.readOnly.endPlanArriveTm = true;
          }
        }
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.stopsReadOnly.push(JSON.parse(JSON.stringify(stopReadOnly)));

            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
            if (shipmentsObjs.stops[i].addrDetail) {
              this.stopsReadOnly[i].addrDetail = true;
            }
            if (shipmentsObjs.stops[i].planArriveTm) {
              this.form.stops[i].planArriveTm = shipmentsObjs.stops[i].planArriveTm;
              this.stopsReadOnly[i].planArriveTm = true;
            }
            if (shipmentsObjs.stops[i].planSendtm) {
              this.form.stops[i].planSendtm = shipmentsObjs.stops[i].planSendtm;
              this.stopsReadOnly[i].planSendtm = true;
            }
            if (shipmentsObjs.stops[i].jobType) {
              this.form.stops[i].jobType = shipmentsObjs.stops[i].jobType;
              this.stopsReadOnly[i].jobType = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerPhone) {
              this.form.stops[i].orderPlacerPhone = shipmentsObjs.stops[i].orderPlacerPhone;
              this.stopsReadOnly[i].orderPlacerPhone = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerName) {
              this.form.stops[i].orderPlacerName = shipmentsObjs.stops[i].orderPlacerName;
              this.stopsReadOnly[i].orderPlacerName = true;
            }

          }
        }
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            if (shipmentsObjs.vehicleType) {
              this.readOnly.vehicleType = true;
            }
            window.setTimeout(function () {
              that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength;
              if (shipmentsObjs.vehicleLength) {
                that.readOnly.vehicleLength = true;
              }
            }, 3000);
            break;
          }
        }

        for (let i = 0; i < fields.length; i++) {
          if (fields[i] === 'quantity') {
            if (shipmentsObjs[fields[i]] && shipmentsObjs[fields[i]] >= 0) {
              this.form[fields[i]] = shipmentsObjs[fields[i]];
            }
          } else {
            this.form[fields[i]] = shipmentsObjs[fields[i]];
          }
          if (shipmentsObjs[fields[i]]) {
            this.readOnly[fields[i]] = true;
          }
        }

        if (shipmentsObjs.expectedPrice) {
          this.form.expectedPrice = shipmentsObjs.expectedPrice;
          window.setTimeout(function () { that.calcPrice(); }, 1000);
        }

        if (this.systemCode === "SF-SX") {
          this.readOnly.fromApi = true;
        }

        this.is_shunxin_order = true;
        this.calcDisAndTm();
      }
    },
    getFileByCode(fileCode) {
      let carImage = '';
      try {
        carImage = require('@/assets/car' + fileCode + '.png')
      } catch(e){
        carImage = require('@/assets/car-default.png')
      }
      return carImage
    }
  }

};